export default "__VITE_ASSET__ac861414__"